module.exports = require("./daterangepicker.js");
require("./daterangepicker.css");


//////////////////
// WEBPACK FOOTER
// bootstrap-daterangepicker (bower component)
// module id = 613
// module chunks = 1